"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDb = exports.toDb = void 0;
const assetVerification_1 = require("./assetVerification");
const assignmentUserInput_1 = require("./assignmentUserInput");
const cashBalanceUserInput_1 = require("./cashBalanceUserInput");
const datalakeWaitUserInput_1 = require("./datalakeWaitUserInput");
const lenderApprovalFlow_1 = require("./lenderApprovalFlow");
// synthetic processes should be defined as series of steps.
// each step is responsible for attaching or detaching its own thing.
// The order is very important. the processes assume the graph in specific state.
// they will be executed in order when saving to db. and in reverse order when reading from db.
const syntheticProcessesToDb = [
    cashBalanceUserInput_1.syntheticProcess,
    assignmentUserInput_1.syntheticProcess,
    lenderApprovalFlow_1.syntheticProcess,
    assetVerification_1.syntheticProcess,
    datalakeWaitUserInput_1.syntheticProcess,
];
const syntheticProcessesFromDb = syntheticProcessesToDb.reverse();
const toDb = (dbGraph) => {
    return syntheticProcessesToDb.reduce((acc, process) => process.toDb(acc), dbGraph);
};
exports.toDb = toDb;
const fromDb = (dbGraph) => {
    return syntheticProcessesFromDb.reduce((acc, process) => process.fromDb(acc), dbGraph);
};
exports.fromDb = fromDb;
//# sourceMappingURL=syntheticOrder.js.map